import { ConcreteEncodable } from "./ConcreteEncodable";

import { LastFillDetailsImplEncoder } from "../../encoder/LastFillDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { LastFillDetails } from "../LastFillDetails";

export class LastFillDetailsImpl extends ConcreteEncodable implements LastFillDetails {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.LastFillDetailsImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=921*/
  public dealId: string;
  /*FID=922*/
  public fillUserId: CubiqTS.Long | null = null;
  /*FID=923*/
  public lastQty: CubiqTS.BigNumber | null = null;
  /*FID=924*/
  public lastSettleQty: CubiqTS.BigNumber | null = null;
  /*FID=925*/
  public tradeDt: CubiqTS.moment.Moment | null = null;
  /*FID=926*/
  public clientFillSptRt: CubiqTS.BigNumber | null = null;
  /*FID=927*/
  public clientFillPts: CubiqTS.BigNumber | null = null;
  /*FID=928*/
  public clientFillSwpPts: CubiqTS.BigNumber | null = null;
  /*FID=929*/
  public clientFillAllInRt: CubiqTS.BigNumber | null = null;
  /*FID=930*/
  public marketFillSptRt: CubiqTS.BigNumber | null = null;
  /*FID=931*/
  public marketFillPts: CubiqTS.BigNumber | null = null;
  /*FID=932*/
  public marketFillSwpPts: CubiqTS.BigNumber | null = null;
  /*FID=933*/
  public marketFillAllInRt: CubiqTS.BigNumber | null = null;
  /*FID=934*/
  public dealSettleTenor: CubiqTS.Tenor;
  /*FID=935*/
  public dealSettleDate: CubiqTS.moment.Moment | null = null;
  /*FID=936*/
  public dealSwpSettleTenor: CubiqTS.Tenor;
  /*FID=937*/
  public dealSwpSettleDate: CubiqTS.moment.Moment | null = null;
  /*FID=938*/
  public dealState: CubiqTS.OrderDealState;
  /*FID=939*/
  public fillDts: CubiqTS.moment.Moment | null = null;
  /*FID=940*/
  public dealRef: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = LastFillDetailsImplEncoder.Instance;
    this.setEncodableType(LastFillDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "LastFillDetailsImpl[" +
      "messageId=" +
      this.messageId +
      "dealId=" +
      this.dealId +
      "fillUserId=" +
      this.fillUserId +
      "lastQty=" +
      this.lastQty +
      "lastSettleQty=" +
      this.lastSettleQty +
      "tradeDt=" +
      this.tradeDt +
      "clientFillSptRt=" +
      this.clientFillSptRt +
      "clientFillPts=" +
      this.clientFillPts +
      "clientFillSwpPts=" +
      this.clientFillSwpPts +
      "clientFillAllInRt=" +
      this.clientFillAllInRt +
      "marketFillSptRt=" +
      this.marketFillSptRt +
      "marketFillPts=" +
      this.marketFillPts +
      "marketFillSwpPts=" +
      this.marketFillSwpPts +
      "marketFillAllInRt=" +
      this.marketFillAllInRt +
      "dealSettleTenor=" +
      this.dealSettleTenor +
      "dealSettleDate=" +
      this.dealSettleDate +
      "dealSwpSettleTenor=" +
      this.dealSwpSettleTenor +
      "dealSwpSettleDate=" +
      this.dealSwpSettleDate +
      "dealState=" +
      this.dealState +
      "fillDts=" +
      this.fillDts +
      "dealRef=" +
      this.dealRef +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
